import React, { useEffect, useMemo, useRef } from "react";
import styles from "./mapMarker.module.css";
import L from "leaflet";
import { Marker, Popup } from "react-leaflet";
import { Link } from "react-router-dom";

export default function MapMarker({
  location,
  setLocation,
  title,
  excerpt,
  linkTo,
  mythData,
  autoOpen = false,
  draggable = false,
}) {
  const leafletRef = useRef();

  let showButton = false;
  let hasComic = false;
  let hasPlace = false;

  if (mythData) {
    const { comicPhoto, placePhoto, audio } = mythData;

    hasComic = comicPhoto && comicPhoto.editedUrl;
    hasPlace = placePhoto && placePhoto.url;
    const hasAudio = audio && audio.url;

    showButton = linkTo && hasAudio && hasPlace && hasComic;
  }

  useEffect(() => {
    if (autoOpen) {
      leafletRef.current.openPopup();
    } else {
      leafletRef.current.closePopup();
    }
  }, [location, autoOpen]);

  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = leafletRef.current;
        if (marker !== null && setLocation) {
          setLocation(marker.getLatLng());
        }
      },
    }),
    [setLocation]
  );

  return location === null ? null : (
    <Marker
      position={location}
      riseOnHover
      ref={leafletRef}
      icon={myIcon}
      draggable={draggable}
      eventHandlers={eventHandlers}
    >
      {(title || excerpt) && (
        <Popup autoClose="false" closeOnClick="false">
          <div className={styles.popupContent}>
            <h2 className={styles.popupTitle}>{title}</h2>
            <p className={styles.popupExcerpt}>{excerpt}...</p>

            {hasComic && (
              <img
                src={mythData.comicPhoto.editedUrl}
                alt="location"
                height={160}
                className={styles.popupImg}
              />
            )}

            {showButton && (
              <div className={styles.popupLinkHolder}>
                <Link className={styles.popupLink} to={linkTo}>
                  Hear the Story...
                </Link>
              </div>
            )}

            {!showButton && (
              <p className={styles.noAudioMessage}>
                We don't have audio for this one yet.
              </p>
            )}
          </div>
        </Popup>
      )}
    </Marker>
  );
}

const myIcon = L.icon({
  iconUrl: "../myth-marker.png",
  iconSize: [33, 42],
  iconAnchor: [16, 42],
  popupAnchor: [2, -32],
  shadowUrl: "../myth-marker-shadow.png",
  shadowSize: [55, 26],
  shadowAnchor: [16, 26],
});
